<template>
  <b-modal
    ref="modal"
    title="Merge PPTX"
    @hide="closeHandler"
    @show="onShowHandler"
  >
    <div v-if="!isLoading">
      <div class="col-12">
        <b-form-group label="Enter file name:">
          <b-form-input
            v-model="resultName"
            type="text"
            placeholder="Enter file name"
            required
          />
        </b-form-group>
      </div>
    </div>

    <div 
      v-else
      class="modal-load"
    >
      <b-spinner />
    </div>

    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        :disabled="isLoading"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
      <ButtonPrimary
        variant="primary"
        :disabled="isLoading"
        @click="accept"
      >
        Merge
      </ButtonPrimary>
    </template>
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from "./mixin"
import {createNamespacedHelpers} from 'vuex'
import Requests from "@frontend/services/api/file-browser";
import {MUTATIONS} from "@frontend/store/file-browser";

const {mapGetters, mapMutations, mapActions} = createNamespacedHelpers('fileBrowser')

const initState = () => ({
  isLoading: false,
  resultName: 'New merged PPTX'
})

export default {
  name: "MergePPTXModal",

  components: {
    ButtonOutline,
    ButtonPrimary,
  },

  mixins: [
    mixinModal
  ],

  data: initState,

  computed: {
    ...mapGetters(['selectedItems'])
  },

  methods: {
    ...mapMutations([MUTATIONS.CLEAR_SELECTION, MUTATIONS.UPDATE_IS_PROCESSING]),
    ...mapActions(['fetchList', 'uploadFiles']),

    reset() {
      const state = initState();
      for (const key in state) {
        this[key] = state[key];
      }
    },

    async onShowHandler() {
      this.reset();
    },

    async accept() {
      try {
        this.isLoading = true;
        const filePaths = this.selectedItems.map((item) => item.path.replace(/^.*file=/, ''));
        const sanitizedResultName = this.resultName.trim().replace(/[^a-zA-Z0-9_\-]/g, '_');
        const fileName = sanitizedResultName !== '' ? sanitizedResultName : 'New merged PPTX';
        const response = await Requests.mergePPTX({
          filePaths, 
          resultName: fileName,
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const file = new File([blob], `${fileName}.pptx`, { type: blob.type });
        
        await this.uploadFiles({
          files: [file],
        })
        
        const link = document.createElement('a');
        
        link.href = URL.createObjectURL(blob);
        link.download = response.headers['content-disposition']
          ?.split('filename=')[1]
          ?.replace(/"/g, '') || 'merged_presentation.pptx';
        link.click();
        
        URL.revokeObjectURL(link.href);
      } catch (error) {
        this.isLoading = false;
        console.error('error:', error);
      }

      this.close();
      this.isLoading = false;
    }
  }
}
</script>


<style scoped lang="scss">
.modal-load {
  display: flex;
  justify-content: center;
}
</style>
